import React from 'react';
import { useLocation } from 'react-router-dom';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import useReports from 'state/hooks/use-reports';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { ReportParams } from 'state/providers/ReportsProvider/types';
import { AppRoutes } from 'types';
import { isUndefined } from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('reports', key, options);

const ReportSectionHeader: React.FC = () => {
  const [{ filters }] = useReports();
  const classes = useStyles();
  const backRoute = getReportBackRoute(filters);
  const omitRoutes = useTrialUserOmitRoutes();
  return (
    <div className={clsx('noPrint', classes.root)}>
      <SectionHeader omitRoutes={omitRoutes} title={t('header')} backRoute={backRoute} />
    </div>
  );
};

const getReportBackRoute = (params: ReportParams) => {
  const location = useLocation();
  let backRoute: string | undefined;
  const baseBackRoute = `/${AppRoutes.REPORTS}`;
  const searchParams = new URLSearchParams(location.search);

  if (!isUndefined(params.selectedStudentId)) {
    searchParams.delete('selectedStudentId');
    backRoute = `${baseBackRoute}?${searchParams.toString()}`;
  } else if (!isUndefined(params.character)) {
    searchParams.delete('character');
    backRoute = `${baseBackRoute}?${searchParams.toString()}`;
  }

  if (location.state?.backRoute) backRoute = location.state?.backRoute;

  return backRoute;
};

const useStyles = makeStyles(() => ({
  root: {
    top: 0,
    flexGrow: 1,
    position: 'sticky',
    zIndex: 99,
  },
}));

export default ReportSectionHeader;
